module.exports = __webpack_public_path__ + "img/promise_title.b7813dfa.png";